// import React from 'react';
import PoolList from './PoolList';
import StandaloneList from './StandaloneList';

export {
  PoolList ,
  StandaloneList
}



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/NotionalPoolSummary/GlsNotionalPoolingStrucutre/index.js